import React, { useState, useEffect } from 'react';
import { ContentBox } from '../ContentBox';
import { getResume2Token, setVal2Token, getval2Token } from '../../../Login/Auth';
import { api_getCustomerPositionList } from '../../../../api/apiCustomerPosition';
import { ReqCustomerPositionList, WageType_Arr, JobDemand_Arr } from '../../../../item/ItemCustomerPosition';
import { getItemsInfo, uuid } from '../../../../item/ItemTools';

export function CustomerPositionList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")
    const [customerContractId, setCustomerContractId] = useState("")
    const [mPositionList, setPositionList] = useState([])

    useEffect(() => {
        if (id !== undefined && id !== "" && id !== tokenId) {
            var obj = getval2Token("customerContract", id)
            console.log(obj)
            setCustomerContractId(obj.customerContractId)
            setTokenId(id)
        }
    }, [id])

    useEffect(() => {
        if (customerContractId !== undefined && customerContractId !== "") {
            var mReqCustomerPositionList = new ReqCustomerPositionList({ customerContractId })
            getCustomerPositiontList(mReqCustomerPositionList)
        }
    }, [customerContractId])

    function getCustomerPositiontList(mReqCustomerPositionList) {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        //console.log("getCustomerContractList")
        //console.log(mReqCustomerContractList)
        api_getCustomerPositionList({
            mReqCustomerPositionList,
            success: (obj) => {
                console.log(obj)
                setPositionList(obj.list)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        var tokenId = uuid(128, 64)
        setVal2Token("customerPosition", {customerContractId}, tokenId)
        window.location.assign("/CustomerPositionAdd/" + tokenId);
    }

    var title = '職缺列表'
    var title_tools =
        <a className="dropdown-toggle " onClick={e => toAdd()} data-toggle="dropdown" href="#A">
            <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">新增</span>
        </a>
    var content =
        <>
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-1">職缺</th>
                                    <th className="text-center sorting col-sm-1">班別</th>
                                    <th className="text-center sorting col-sm-1">類別</th>
                                    <th className="text-center sorting col-sm-2">需求量</th>
                                    <th className="text-center sorting col-sm-3">工作地點</th>
                                    <th className="text-center sorting col-sm-4">工作地址</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    mPositionList.map((position) => (
                                        <PositionBox key={position.customerPositionId} position={position} tokenId={tokenId} />
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    return (
        <>
            <ContentBox title={title} title_tools={title_tools} content={content} hasDrawer={false} />
        </>
    )
}


function PositionBox({ position, tokenId }) {
    const [customerContractId, setCustomerContractId] = useState("")
    const [customerPositionId, setCustomerPositionId] = useState("")
    const [mPosition, setPosition] = useState({})
    const [job, setJob] = useState("")
    const [shift, setShift] = useState("")
    const [wageType, setWageType] = useState(0)
    const [jobDemand, setJobDemand] = useState(0)
    const [workPlace, setWorkPlace] = useState(0)
    const [workAddress, setWorkAddress] = useState(0)

    useEffect(() => {
        if (position !== undefined && position !== mPosition) {
            console.log(position)
            setCustomerContractId(position.customerContractId)
            setCustomerPositionId(position.customerPositionId)
            setPosition(position)
            setJob(position.job)
            setShift(position.shift)
            setWageType(position.wageType)
            setJobDemand(position.jobDemand)
            setWorkPlace(position.workPlace)
            setWorkAddress(position.workAddress)
        }
    }, [position])

    function toDetail() {
        var tokenId = uuid(128, 64)
        setVal2Token("customerPosition", {customerContractId, customerPositionId}, tokenId)
        window.location.assign("/CustomerPositionDetail/" + tokenId);
    }

    return (
        <tr role="row">
            <td className="text-center"><a href="#A" onClick={e => toDetail()}>{job}</a>&nbsp;</td>
            <td className="text-center">{shift}</td>
            <td className="text-center">{getItemsInfo({items:WageType_Arr, val:wageType})}</td>
            <td className="text-center">{getItemsInfo({items:JobDemand_Arr, val:jobDemand})}</td>
            <td className="text-center">{workPlace}</td>
            <td className="text-center">{workAddress}</td>
        </tr>
    )
}
